import { render, staticRenderFns } from "./DPlayer.vue?vue&type=template&id=94941f74&scoped=true"
import script from "./DPlayer.vue?vue&type=script&lang=js"
export * from "./DPlayer.vue?vue&type=script&lang=js"
import style0 from "./DPlayer.vue?vue&type=style&index=0&id=94941f74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94941f74",
  null
  
)

export default component.exports